import React from "react";

interface FloaterButtonProps {
  onClick: () => void;
  ariaLabel: string;
  /** Icon content. Ignored when `avatarUrl` is set. */
  icon?: React.ReactNode;
  /** Renders a circular photo instead of an icon (e.g. the profile floater). */
  avatarUrl?: string;
  badgeCount?: number;
}

/**
 * Shared purple-glassmorphism circle button used by the floating top rows
 * (Profile/Messages/Notifications on home, Filter/Save on the animal lists,
 * PawMatch navbar actions). Presentational only — callers own visibility and
 * navigation.
 */
const FloaterButton: React.FC<FloaterButtonProps> = ({
  onClick,
  ariaLabel,
  icon,
  avatarUrl,
  badgeCount,
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    className="pointer-events-auto relative flex items-center justify-center h-11 w-11 rounded-full text-golden border border-white/20 focus:outline-none focus:ring-2 focus:ring-gradient-blue"
    style={{
      background:
        "linear-gradient(135deg, rgba(139,58,182,0.55), rgba(70,18,102,0.55))",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      boxShadow:
        "0 8px 32px rgba(0,0,0,0.45), 0 2px 10px rgba(139,58,182,0.5), inset 0 1px 0 rgba(255,255,255,0.14)",
    }}
  >
    <span className="flex h-full w-full items-center justify-center overflow-hidden rounded-full">
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt=""
          className="h-full w-full object-cover"
          referrerPolicy="no-referrer"
        />
      ) : (
        icon
      )}
    </span>
    {!!badgeCount && badgeCount > 0 && (
      <span
        className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold leading-none"
        aria-hidden="true"
      >
        {badgeCount > 99 ? "99+" : badgeCount}
      </span>
    )}
  </button>
);

export default FloaterButton;
